import React from "react";
import {Link} from "react-router-dom";
import ItemImage from "./ItemImage";

const ItemCard = ({item}) => {
    const totalStock = item.variants.reduce((total, variant) => total + variant.stockQuantity, 0);
    const isSoldOut = totalStock === 0;

    return (
        <Link
            to={`/shop/items/${item.uuid}`}
            className="flex flex-col bg-white shadow rounded-lg border border-gray-200 hover:bg-gray-50 overflow-hidden"
        >
            <div className="relative w-full aspect-square bg-gray-100">
                <ItemImage src={item.image} alt={item.name} className="w-full h-full object-cover"/>
                {isSoldOut && (
                    <span className="absolute top-2 right-2 bg-gray-800 text-white text-xs font-semibold px-2 py-1 rounded">
                        Ausverkauft
                    </span>
                )}
            </div>
            <div className="p-4 flex-1 flex flex-col">
                <h3 className="font-semibold text-gray-800">{item.name}</h3>
                <p className="text-sm text-gray-500 mt-auto pt-2">
                    {item.bruttoPrice.toFixed(2)} {item.currency.toUpperCase()}
                </p>
            </div>
        </Link>
    );
};

export default ItemCard;
